import { camelCase, kebabCase } from 'lodash'

import type { Block, Inline, Document as RichTextDocument, Text } from '@contentful/rich-text-types'

import createCompanyLogosComponent from '@segment/matcha/components/CompanyLogos/utils/createCompanyLogosComponent'

import type { LogoTrackProps } from '@segment/matcha/recipes/LogoCarousel/LogoTrack'

import type { Media } from '@segment/api/types/templates/base'

import TemplateImage from './TemplateImage'

export const toLogos = (logos: Media[]): LogoTrackProps[`icons`] => {
  return logos.map((logo) => ({
    id: kebabCase(logo.title || ``),
    width: logo.width || 0,
    height: logo.height || 0,
    icon: createCompanyLogosComponent(
      <TemplateImage key={logo.title} {...logo} />,
      `${camelCase(logo.title)}Logo`,
      `Company`
    ),
  }))
}

export type AvailableFontVariant = `h1` | `h2` | `h3` | `pExtraLarge` | `pLarge` | `pMedium` | `pSmall`

export const getFontSizeVariant = (
  content: string,
  breakpoints: Map<number, AvailableFontVariant>
): AvailableFontVariant => {
  const characterCount = content.length
  const breakpoint = Array.from(breakpoints.keys()).find((key) => characterCount > key) || 0

  return breakpoints.get(breakpoint) || `pLarge`
}

type RichTextType = Block | Inline | Text

export enum RichTextCharacterLimitType {
  PARAGRAPH = `p`,
  LIST = `ul`,
}

export const getNumCharactersFromRichText = (richTextContent: RichTextType[]): number => {
  let characterCount = 0
  richTextContent.forEach((item: RichTextType) => {
    if ((item.nodeType as any) === `text`) {
      const { value } = item as Text
      characterCount += value.length
    } else if (Array.isArray((item as Block).content)) {
      characterCount += getNumCharactersFromRichText((item as Block).content)
    }
  })
  return characterCount
}

export const getRichTextFontSizeVariant = (
  richText: RichTextDocument,
  breakpoints: Map<number, AvailableFontVariant>
): AvailableFontVariant => {
  const characterCount = getNumCharactersFromRichText(richText.content)
  const breakpoint = Array.from(breakpoints.keys()).find((key) => characterCount > key) || 0

  return breakpoints.get(breakpoint) || `pLarge`
}
